var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"digital-flop-container"},[_c('dv-border-box-11',{staticClass:"dv-border-box",attrs:{"title":"新车指导价"}},[_c('dv-digital-flop',{staticStyle:{"width":"auto","height":"100px"},attrs:{"config":_vm.config}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }